function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { TextareaField } from 'decap-cms-ui-next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export default class TextControl extends React.Component {
  /**
   * Always update to ensure `react-textarea-autosize` properly calculates
   * height. Certain situations, such as this widget being nested in a list
   * item that gets rearranged, can leave the textarea in a minimal height
   * state. Always updating this particular widget should generally be low cost,
   * but this should be optimized in the future.
   */
  shouldComponentUpdate() {
    return true;
  }
  render() {
    const {
      forID,
      label,
      status,
      placeholder,
      description,
      inline,
      value,
      onChange,
      error,
      errors
    } = this.props;
    return ___EmotionJSX(TextareaField, {
      name: forID,
      label: label,
      status: status,
      placeholder: placeholder,
      description: description,
      inline: inline,
      value: value || '',
      minRows: 5,
      onChange: e => onChange(e.target.value),
      error: error,
      errors: errors
    });
  }
}
_defineProperty(TextControl, "propTypes", {
  onChange: PropTypes.func.isRequired,
  forID: PropTypes.string,
  value: PropTypes.node,
  classNameWrapper: PropTypes.string.isRequired,
  setActiveStyle: PropTypes.func.isRequired,
  setInactiveStyle: PropTypes.func.isRequired
});
_defineProperty(TextControl, "defaultProps", {
  value: ''
});